export const collections = {
    USERS: 'users',
    SEMINARS: 'seminars',
    LECTORS: 'lectors',
    CONFIGS: 'configs',
    GALLERY: 'gallery',
    USER_REGISTRATIONS: 'user-registrations'
}